import React from "react";
import { Link } from "react-router-dom";
import iconMyOrders from "../../images/Icons/iconMyOrders.svg";
import iconPayments from "../../images/Icons/iconPayments.svg";
import iconMyData from "../../images/Icons/iconMyData.svg";
import iconLogout from "../../images/Icons/iconLogout.svg";
import { useNavigate } from "react-router-dom";

import "./account-sidebar.scss";

const AccountSidebar = () => {
  const navigate = useNavigate();
  const navigateTo = (to) => {
    navigate(to);
  };

  return (
    <div className={"sidebar"}>
      <ul className={"menu"}>
        <li className={"menuItem"} onClick={() => navigateTo("/meus-pedidos")}>
          <img src={iconMyOrders} alt="" />
          <Link to={"/meus-pedidos"} className={"nav-link"}>
            MEUS PEDIDOS
          </Link>
        </li>
        <li className={"menuItem"} onClick={() => navigateTo("/pagamentos")}>
          <img src={iconPayments} alt="" />
          <Link to={"/pagamentos"} className={"nav-link"}>
            PAGAMENTOS
          </Link>
        </li>
        <li className={"menuItem"} onClick={() => navigateTo("/my-account")}>
          <img src={iconMyData} alt="" />
          <Link to={"/my-account"} className={"nav-link"}>
            MEUS DADOS
          </Link>
        </li>
        <li className={"menuItem"} onClick={() => {
           localStorage.removeItem('authUser');
           localStorage.removeItem('franchise');
           navigateTo("/");
           window.location.reload();
        }}>
          <img src={iconLogout} alt="" />
          <a className={"nav-link"}>SAIR</a>
        </li>
      </ul>
    </div>
  );
};

export default AccountSidebar;
